<template>
     <section class="section section-shaped section-lg my-0">
       <div class="shape shape-style-1 bg-gradient-default">
            <span class="span-150"></span>
            <span class="span-50"></span>
            <span class="span-50"></span>
            <span class="span-75"></span>
            <span class="span-100"></span>
        </div>
        <!--div class="container shape-container d-flex align-items-center">
            <div class="col px-0">
                <div class="row justify-content-center align-items-center">
                    <div class="col-lg-8 text-center pt-lg">
                        <img src="img/logo.png" style="width: 256px;" class="img-fluid">
                        <p class="lead text-white mt-4 mb-5">We provide full stack AI services and solutions for enterprise applications.</p>
                        <div class="btn-wrapper">
                            <base-button  class="mb-3 mb-sm-0" type="info">
                                <router-link to="/login" class="dropdown-item">Get started</router-link>
                            </base-button>
                            <base-button class="mb-3 mb-sm-0"
                                         type="white">
                                <router-link to="/contact" class="dropdown-item">Contact us</router-link>
                            </base-button>
                        </div>
                    </div>
                </div>
            </div>
        </div-->

        <div class="container shape-container d-flex align-items-center">
             <div class="col px-0">
                <div class="row justify-content-center align-items-center">
                    <div class="col-lg-8 text-center pt-lg"> 
                        <h4 class="display-4 text-white">Data + Intellgence + Platform</h4>
                        <h1 class="display-2  text-white">One Stop AI Solution</h1>
                        <p class="lead text-white">Magicom is an AI-as-a-service (AaaS) service company, providing full-stack intellegence services and solutions ranging from data process(collection, clean, augmentation and annotation), model development(training and deployment) and enterprise applications.</p>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
export default {};
</script>
<style>
</style>
